import { Button } from "@mui/material";
import { useState } from "react";
import useAPI from "../../../../api/hooks/useAPI";
import useColors from "../../../../api/hooks/useColors";
import CustomToolTip from "../../../../components/CustomTooltip";
import SpinningIcon from "../../../../components/SpinningIcon";
import { Toast } from "../../../../components/Toast";
import ConfirmationDialog from "../../../../components/dialogs/ConfirmationDialog";

const GenerateInternalDashboardSnapshotsButton = ({ ...props }) => {
  const colors = useColors();
  const { generateInternalDashboardSnapshots } = useAPI();
  const [openDialog, setOpenDialog] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleButtonClick = () => {
    setOpenDialog(true);
  };

  const handleDialogClose = () => {
    setOpenDialog(false);
  };

  const handleConfirm = async () => {
    setIsLoading(true);
    setOpenDialog(false);
    try {
      const result = await generateInternalDashboardSnapshots();
      const data = result.data;
      Toast.success(
        `Generated snapshots for ${data.customers_processed} customers${
          data.errors > 0 ? ` (${data.errors} errors)` : ""
        }`
      );
    } catch (error) {
      Toast.error("Failed to generate snapshots");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <CustomToolTip
        title={isLoading ? "Generating internal dashboard snapshots..." : ""}
      >
        <Button
          sx={{
            background: colors.grey_50,
            color: colors.contrast_text_dark,
            height: "32px",
            marginLeft: "5px",
            border: "1px solid",
            borderRadius: "8px",
          }}
          startIcon={<SpinningIcon isLoading={isLoading} />}
          onClick={handleButtonClick}
          disabled={isLoading}
          {...props}
        >
          {isLoading
            ? "Generating..."
            : "Generate Internal Dashboard Snapshots"}
        </Button>
      </CustomToolTip>
      <ConfirmationDialog
        openDialog={openDialog}
        handleDialogClose={handleDialogClose}
        handleConfirm={handleConfirm}
        dialogContentFirstLine="Generate internal dashboard snapshots for all customers?"
        dialogContentSecondLine="This will create/update today's snapshot files in S3."
        confirmationButtonText="Generate"
      />
    </>
  );
};

export default GenerateInternalDashboardSnapshotsButton;
